import { ActivitiesInternalResource as e } from "./resources/ActivitiesInternalResource.js";
import { AgentConfigurationResource as t } from "./resources/agent-configuration/AgentConfigurationResource.js";
import { AnswerResource as n } from "./resources/answer/AnswerResource.js";
import { AutomationFreezesResource as r } from "./resources/AutomationFreezesResource.js";
import { BatchAnswerResource as i } from "./resources/batch-answer/BatchAnswerResource.js";
import { CaseAssistConfigsInternalResource as a } from "./resources/CaseAssistConfigstInternalResource.js";
import { ChunkInspectorResource as o } from "./resources/chunk-inspector/ChunkInspectorResource.js";
import { CommerceResource as s } from "./resources/commerce/Commerce.js";
import { ConditionResource as c } from "./resources/ConditionResource.js";
import { CrawlingModuleInternalResource as l } from "./resources/CrawlingModuleInternalResource.js";
import { CRGADashboardResource as u } from "./resources/crga-dashboard/CRGADashboardResource.js";
import { DataServiceResource as d } from "./resources/DataServiceResource.js";
import { DocumentIdentityResource as f } from "./resources/DocumentIdentityResource.js";
import { ExportServiceResource as p } from "./resources/ExportServiceResource.js";
import { ExtensionInternalResource as m } from "./resources/ExtensionInternalResource.js";
import { HostedPagesInternalResource as h } from "./resources/HostedPagesInternalResource.js";
import { InAppWidgetResource as g } from "./resources/InAppWidgetResource.js";
import { InsightPanelConfigsInternalResource as _ } from "./resources/InsightPanelConfigsInternalResource.js";
import { IPXInterfaceExperimentalResource as v } from "./resources/IPXInterfaceResource.js";
import { LicenseInternalResource as y } from "./resources/LicenseInternalResource.js";
import { LogicalIndexesResource as b } from "./resources/LogicalIndexesResource.js";
import { MCPConfigurationsResource as x } from "./resources/MCPConfigurationsResource.js";
import { MCPPipelinesResource as S } from "./resources/MCPPipelinesResource.js";
import { ModelsInternalResource as C } from "./resources/ModelsInternalResource.js";
import { NextGenSearchPagesInternalResource as w } from "./resources/NextGenSearchPagesInternalResource.js";
import { NotificationEventResource as T } from "./resources/NotificationEventResource.js";
import { OrganizationCustomerKeysResource as E } from "./resources/OrganizationCustomerKeysResource.js";
import { OrganizationDefinitionResource as D } from "./resources/OrganizationDefinitionResource.js";
import { OrganizationHealthMonitoringResource as O } from "./resources/OrganizationHealthMonitoringResource.js";
import { OrganizationInternalResource as k } from "./resources/OrganizationInternalResource.js";
import { OrganizationMonitoringResource as A } from "./resources/OrganizationMonitoringResource.js";
import { OrganizationQuotasResource as j } from "./resources/OrganizationQuotasResource.js";
import { OrganizationSettingsResource as M } from "./resources/OrganizationSettingsResource.js";
import { PipelineInternalResource as N } from "./resources/PipelineInternalResource.js";
import { PipelineSettingsResource as P } from "./resources/PipelineSettingsResource.js";
import { PreviewResource as F } from "./resources/PreviewResource.js";
import { PrivateLicenseResource as I } from "./resources/PrivateLicenseResource.js";
import { PrivilegesResource as L } from "./resources/PrivilegesResource.js";
import { ProjectInternalResource as R } from "./resources/ProjectInternalResource.js";
import { ReportInternalResource as z } from "./resources/ReportInternalResource.js";
import { SalesforceSourceConfigurationInternalResource as B } from "./resources/SalesforceSourceConfigurationInternalResource.js";
import { SchemaServiceTemporaryResource as V } from "./resources/SchemaServiceTemporaryResource.js";
import { SearchDictionaryFieldsResource as H } from "./resources/SearchDictionaryFieldsResource.js";
import { SearchInterfacesInternalResource as U } from "./resources/SearchInterfacesInternalResource.js";
import { SearchPagesInternalResource as W } from "./resources/SearchPagesInternalResource.js";
import { SecurityCacheInternalResource as G } from "./resources/SecurityCacheInternalResource.js";
import { SourcesInternalResource as K } from "./resources/SourcesInternalResource.js";
import { PlatformClient as q } from "@coveo/platform-client";
//#region src/PrivatePlatformClient.ts
var J = [
	{
		key: "activitiesInternal",
		resource: e
	},
	{
		key: "agentConfiguration",
		resource: t
	},
	{
		key: "answer",
		resource: n
	},
	{
		key: "automationFreezes",
		resource: r
	},
	{
		key: "batchAnswer",
		resource: i
	},
	{
		key: "caseAssistConfigsInternal",
		resource: a
	},
	{
		key: "chunkInspector",
		resource: o
	},
	{
		key: "commerce",
		resource: s
	},
	{
		key: "condition",
		resource: c
	},
	{
		key: "crawlingModuleInternal",
		resource: l
	},
	{
		key: "crgaDashboard",
		resource: u
	},
	{
		key: "dataService",
		resource: d
	},
	{
		key: "documentIdentity",
		resource: f
	},
	{
		key: "exportService",
		resource: p
	},
	{
		key: "extensionInternal",
		resource: m
	},
	{
		key: "inAppWidget",
		resource: g
	},
	{
		key: "insightPanelConfigsInternal",
		resource: _
	},
	{
		key: "hostedPagesInternal",
		resource: h
	},
	{
		key: "ipxInterfaceExperimental",
		resource: v
	},
	{
		key: "licenseInternal",
		resource: y
	},
	{
		key: "logicalIndexes",
		resource: b
	},
	{
		key: "mcpConfigurations",
		resource: x
	},
	{
		key: "mcpPipelines",
		resource: S
	},
	{
		key: "modelsInternal",
		resource: C
	},
	{
		key: "nextGenSearchPagesInternal",
		resource: w
	},
	{
		key: "notificationEvent",
		resource: T
	},
	{
		key: "organizationInternal",
		resource: k
	},
	{
		key: "organizationCustomerKeys",
		resource: E
	},
	{
		key: "organizationDefinition",
		resource: D
	},
	{
		key: "organizationQuotas",
		resource: j
	},
	{
		key: "organizationHealthMonitoring",
		resource: O
	},
	{
		key: "organizationMonitoring",
		resource: A
	},
	{
		key: "organizationSettings",
		resource: M
	},
	{
		key: "pipelineInternal",
		resource: N
	},
	{
		key: "pipelineSettings",
		resource: P
	},
	{
		key: "privateLicense",
		resource: I
	},
	{
		key: "preview",
		resource: F
	},
	{
		key: "privileges",
		resource: L
	},
	{
		key: "projectInternal",
		resource: R
	},
	{
		key: "reportInternalResource",
		resource: z
	},
	{
		key: "salesforceSourceConfigurationInternal",
		resource: B
	},
	{
		key: "schemaServiceTemporary",
		resource: V
	},
	{
		key: "searchDictionaryFields",
		resource: H
	},
	{
		key: "searchInterfacesInternal",
		resource: U
	},
	{
		key: "searchPagesInternal",
		resource: W
	},
	{
		key: "sourcesInternal",
		resource: K
	},
	{
		key: "securityCacheInternal",
		resource: G
	}
], Y = class extends q {
	constructor(e) {
		super(e), J.forEach(({ key: e, resource: t }) => {
			this[e] = new t(this.API, this.ServerlessAPI);
		});
	}
};
//#endregion
export { Y as PrivatePlatformClient };

//# sourceMappingURL=PrivatePlatformClient.js.map